import React from 'react';
import classes from './DocumentList.module.css';
import { IDocument } from '../../store/slices/documents';
import { DocumentCard } from './DocumentCard';
import { IAttachment } from '../UI/SelectedSalesOrder/DigitalHealthProfileTab';

type Props = {
  documents: IDocument[] | IAttachment[];
  fullWidth?: boolean;
  handleDelete?: (id: string) => void;
  hideDownload?: boolean;
  isLoading?: boolean;
  userInfo?: any;
};

const DocumentList: React.FC<Props> = ({
  documents,
  fullWidth,
  handleDelete,
  hideDownload,
  isLoading,
  userInfo,
}) => {
  const sortedDocuments = [...documents].sort((a, b) => {
    const dateA = new Date(a.datetime_created ?? '').getTime();
    const dateB = new Date(b.datetime_created ?? '').getTime();
    return dateB - dateA;
  });
  return (
    <div className={`${fullWidth ? classes.listView : classes.container}`}>
      {sortedDocuments?.map((document, idx) => {
        const documentId = (document as IDocument).id;
        return (
          <DocumentCard
            hideDownload={documentId ? true : false}
            isLoading={isLoading}
            mimeType={(document as IDocument).mime_type ?? document.name?.split('.').slice(-1)[0]}
            key={idx}
            document={document}
            userInfo={userInfo}
            handleDelete={handleDelete ? () => handleDelete(documentId) : undefined}
          />
        );
      })}
    </div>
  );
};

export { DocumentList };
